import React from 'react';
import '../CSS/contact.css';

import FirebaseDb from "../firebase"


import ContactForm from '../Components/contactForm'

import ContactInfo from '../Components/contactUsInfo'
import Navbar from 'react-bootstrap/Navbar';
import logo from '../Assets/command-line.png';
import { Link } from 'react-router-dom';
import emailjs from 'emailjs-com';





const add = obj => {
    FirebaseDb.child('contacts').push(
        obj,
        err => {
            if (err)
                console.log(err)   
        }

    )
}


const sendFeedback = (templateId, variables) => {
    emailjs.send('compilelabs', templateId, variables, 'user_BkThWUsfhkZZOfoMDxv65')
        .then(res => {
          console.log('Email successfully sent!')
        })
        // Handle errors here however you like, or use a React error boundary
        .catch(err => console.error('Oh well, you failed. Here some thoughts on the error that occured:', err))
}






class Contact extends React.Component{



    render(){
        return(
            <div>
                <Navbar expand="lg" className="nav" fixed="top" style={{position: "unset"}}>
                <Link to='/'>
                    <Navbar.Brand style={{ marginRight: '0px' }}>
                        <img src={logo} width="60" height="60" className="d-inline-block align-top App-logo" alt="Compile Labs Logo - Mobile/Web Design and Development" />
                    </Navbar.Brand>
                </Link>
                    <Navbar.Brand className="navtitle">Compile Labs</Navbar.Brand>
                </Navbar>
             
                    < ContactInfo />

                 

                    < ContactForm add={add} sendFeedback={sendFeedback} />
            

            </div>
        )
    }
}



export default Contact;
